import EditNote from "@mui/icons-material/EditNote";
import EditOff from "@mui/icons-material/EditOff";
import { IconButton, Tooltip } from "@mui/material";

import { useScoutWriteAccessControl } from "../hooks/useScoutWriteAccessControl";

export type ScoutWriteAccessIndicatorProps = {
  allowMutations: boolean;
  onAllowMutationsChange: (next: boolean) => void;
  disabled?: boolean;
};

export function ScoutWriteAccessIndicator({
  allowMutations,
  onAllowMutationsChange,
  disabled = false,
}: ScoutWriteAccessIndicatorProps) {
  const { isFeatureEnabled, toggle, indicatorTooltip, indicatorAriaLabel } =
    useScoutWriteAccessControl({
      allowMutations,
      onAllowMutationsChange,
      disabled,
    });

  if (!isFeatureEnabled) {
    return null;
  }

  const Icon = allowMutations ? EditNote : EditOff;

  return (
    <Tooltip title={indicatorTooltip} arrow>
      <span
        style={{
          display: "inline-flex",
          cursor: disabled ? "default" : "pointer",
        }}
      >
        <IconButton
          onClick={toggle}
          onMouseDown={(event) => event.preventDefault()}
          disabled={disabled}
          aria-label={indicatorAriaLabel}
          aria-pressed={allowMutations}
        >
          <Icon sx={{ fontSize: 20 }} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
